/** Task numbers: per team, shown as T-42 (not #42, which is a #tag). */

export function formatTaskNumber(number: number | null | undefined): string {
  return number ? `T-${number}` : '';
}

/** "T-42", "t42" or "42" → 42; anything else → null. */
export function parseTaskNumber(value: string): number | null {
  const match = /^\s*(?:t-?)?(\d{1,9})\s*$/i.exec(value);
  if (!match) return null;
  const number = Number(match[1]);
  return number > 0 ? number : null;
}
